import {
    BillingProvider,
    DocumentPreviewProvider,
    DossierDocumentsProvider,
    DocumentSignModal,
    DocumentSignModalProvider,
    DossierDocumentSignProvider,
    DossierPrescriberProvider,
    SelectGreffeModal,
    useDefaultContextActions,
    TypeDocumentsProvider,
    CurrentDossierProvider,
} from '@europrocurement/l2d-modules';
import { Container } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import { DetailDossierHeader, DossierBody } from '../../components';

const DetailDossier: React.FunctionComponent = function () {
    const { idDossier } = useParams();

    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);
    if (!idDossier) {
        console.log(`Dossier non trouvé paramètres url:  ${idDossier}`);
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }
    return (
        <CurrentDossierProvider
            autoload
            idDossier={idDossier}
        >
            <DocumentSignModalProvider>
                <DossierDocumentSignProvider>
                    <TypeDocumentsProvider autoload>
                        <DossierDocumentsProvider
                            autoload
                            dossierIds={[idDossier] as unknown as string[]}
                        >
                            <BillingProvider origine="B2D">
                                <DocumentPreviewProvider>
                                    <Container maxWidth="lg">
                                        <DossierPrescriberProvider>
                                            <DetailDossierHeader />
                                            <DossierBody />
                                        </DossierPrescriberProvider>
                                    </Container>
                                    <DocumentSignModal />
                                </DocumentPreviewProvider>
                            </BillingProvider>
                        </DossierDocumentsProvider>
                    </TypeDocumentsProvider>
                    <SelectGreffeModal />
                </DossierDocumentSignProvider>
            </DocumentSignModalProvider>
        </CurrentDossierProvider>
    );
};

export default DetailDossier;
